import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "m-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "subHeader" }, "View experience")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "m-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "subHeader" }, "View projects")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.mobileHomeLinks)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.mobileHomeMenuItem),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/experience')))
    }, [
      _hoisted_1,
      _createElementVNode("img", {
        class: _normalizeClass(_ctx.$style.arrowIcon),
        src: "https://static.thenounproject.com/png/8212-200.png"
      }, null, 2)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.mobileHomeMenuItem),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/projects')))
    }, [
      _hoisted_2,
      _createElementVNode("img", {
        class: _normalizeClass(_ctx.$style.arrowIcon),
        src: "https://static.thenounproject.com/png/8212-200.png"
      }, null, 2)
    ], 2)
  ], 2))
}